import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { navLinks, profile } from "../mock";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("home");

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 24);
      const offsets = navLinks
        .map((l) => {
          const el = document.getElementById(l.id);
          if (!el) return null;
          const rect = el.getBoundingClientRect();
          return { id: l.id, top: rect.top };
        })
        .filter(Boolean);
      const current = offsets
        .filter((o) => o.top <= 120)
        .sort((a, b) => b.top - a.top)[0];
      if (current) setActive(current.id);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#0a0a0a]/85 backdrop-blur-md border-b border-[#f4f1ea]/8"
          : "bg-transparent"
      }`}
    >
      <div className="container-x flex items-center justify-between h-20">
        <button
          onClick={() => handleNav("home")}
          className="font-mono text-sm font-semibold tracking-tight flex items-center gap-2 text-[#f4f1ea]"
          aria-label="Home"
        >
          <span className="inline-block w-2.5 h-2.5 bg-[#a01d3f]" />
          <span>uswa<span className="text-[#a01d3f]">.</span>dev</span>
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {navLinks.map((link, i) => (
            <button
              key={link.id}
              onClick={() => handleNav(link.id)}
              className={`text-sm font-medium tracking-wide transition-colors duration-200 link-underline flex items-center gap-1.5 ${
                active === link.id ? "text-[#f4f1ea]" : "text-[#f4f1ea]/55 hover:text-[#f4f1ea]"
              }`}
            >
              <span className="font-mono text-[10px] text-[#a01d3f]/70">0{i + 1}</span>
              {link.label}
            </button>
          ))}
        </nav>
        <button
          className="md:hidden p-2 -mr-2 text-[#f4f1ea]"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#0a0a0a] border-t border-[#f4f1ea]/8">
          <div className="container-x py-6 flex flex-col gap-1">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => handleNav(link.id)}
                className={`text-left py-3 text-base font-medium ${
                  active === link.id ? "text-[#a01d3f]" : "text-[#f4f1ea]"
                }`}
              >
                {link.label}
              </button>
            ))}

          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
